import { Signal } from '../core/Signal';

export interface PlayerReadyPayload {
  playerId: string;
  playerName: string;
  timestamp: number;
}

export interface PlayerJoinPayload {
  playerId: string;
  playerName: string;
  timestamp: number;
}

export interface PlayerLeavePayload {
  playerId: string;
  playerName: string;
  timestamp: number;
  reason?: string;
}

export const createPlayerSignals = (debugMode: boolean = false) => ({
  playerReady: new Signal<PlayerReadyPayload>('player.playerReady', debugMode),
  playerJoin: new Signal<PlayerJoinPayload>('player.playerJoin', debugMode),
  playerLeave: new Signal<PlayerLeavePayload>('player.playerLeave', debugMode),
});

export type PlayerSignals = ReturnType<typeof createPlayerSignals>;
